module.exports = __webpack_public_path__ + "img/H1-5.91c3c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/H1-5.png
// module id = 76/X
// module chunks = 15